export default __webpack_public_path__ + "static/media/vi_ComparsaII.2449e163.mp4";